import * as React from 'react';

import Authorization from '../../stores/Authorization';
import { IReportTypeModel } from '../../interfaces/Report/IReport';
import { IUserModel } from '../../interfaces/IUser';
import { IValidation } from '../../interfaces/IError';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { PageWithAffixedHeader } from '../../shared/PageWithAffixedHeader';
import { SystemGeneratedDocumentsTypesEnum } from '../../utilities/Constants';
import ValidateUtils from '../../shared/validations';
import { ZoneContextType } from '../../utilities/Constants';

interface IReportListHomeProps {
    user: IUserModel;
    zoneContext: ZoneContextType;
}

interface IReportListHomeState {
    reportTypes: IReportTypeModel[];
    validation: IValidation;
}

export class ReportListHome extends React.Component<IReportListHomeProps, IReportListHomeState> {
    constructor(props: IReportListHomeProps) {
        super(props);

        this.state = {
            reportTypes: [],
            validation: {},
        };
    }

    componentDidMount() {
        if (
            !Authorization.isAuthorizedToRoute(
                LocalRoutes.ReportTypeList,
                this.props.user,
                this.props.zoneContext.zoneGuid
            )
        )
            window.location.assign(LocalRoutes.AccessDenied);

        this.loadReportTypes();
    }

    loadReportTypes = async () => {
        const response = await this.props.zoneContext.zoneApiClient.getReportTypes();

        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            this.setState({
                validation: ValidateUtils.parseErrors(response.errors, response.errorMessage),
            });
            return;
        }

        // AR - Temp fix to remove 2 report types from the Report Tool in R2.0.0. Will be revisted very soon (Possibly 2.1.0)
        const reportTypes: IReportTypeModel[] = response.payload
            ? response.payload.filter(
                  (x) =>
                      x.id !== SystemGeneratedDocumentsTypesEnum.LocalCounselMeetingAgendaReport.Value &&
                      x.id !== SystemGeneratedDocumentsTypesEnum.PackageSettlementDetail.Value
              )
            : [];

        if (response.payload) {
            this.setState({ reportTypes: reportTypes });
        }
    };

    render() {
        return (
            <PageWithAffixedHeader headerComponent={<h1>Report Tool</h1>}>
                <span className="text-danger">{this.state.validation.model}</span>
                <ul>
                    {this.state.reportTypes.map((item: IReportTypeModel) => {
                        const toUrl = item.clientRouteUrl
                            ? item.clientRouteUrl
                            : LocalRoutes.ReportDetail.replace(':id', item.id.toString());
                        return (
                            <li key={item.id}>
                                <Link to={this.props.zoneContext.buildZoneUrl(toUrl)}>
                                    <span className="btn btn-no-bg text-gray">
                                        <i
                                            className={
                                                item.name == 'PackageSettlements'
                                                    ? 'fal fa-box-usd'
                                                    : 'fal fa-file-chart-column'
                                            }
                                        />
                                        &nbsp;{item.displayName}
                                    </span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </PageWithAffixedHeader>
        );
    }
}
